// Import basic Rails functionality
import Rails from '@rails/ujs'
import '@hotwired/turbo-rails'

// Import jQuery
import $ from 'jquery'
window.$ = window.jQuery = $

// Import welcome-specific styles
import '../css/welcome.css'

// Initialize Rails UJS (only once)
if (!window.Rails) {
  Rails.start()
  window.Rails = Rails
}
